<template>
<div class="header row">
  <img/>
 <h2> Name </h2>
    <p class="time">{{ time }}</p>

</div>
</template>

<script>
export default {
  name: "Header.vue",
  props:{
    time: String
  },
}
</script>

<style lang="scss" scoped>
.header{
  min-width: 100vw;
  min-height: 10vh;
}
.time{
  font-family: "Digital Numbers", serif;
  text-align: right;
  font-size: 3em;
}
.label-logo{
  font-weight: bold;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  text-transform: uppercase;
}
</style>